<template>
    <div id="cadastrar-beneficiario">
        <b-modal id="modal-cadastrar-beneficiario" centered body-class="body-class container py-3 px-3" size="lg" :visible="true"
        no-close-on-backdrop no-close-on-esc @hidden="$emit('close')">
            <template #modal-title >
                <DynamicIcon :icon="iconByTipoBeneficiario" classString="container-modal-title-icon mr-2"/>
                <p> {{ titleByAcao +' '+ titleByTipoBeneficiario }} </p>           
            </template>
            <div class="row m-0">
                <template v-if="checkTipoBeneficiario == 'TITULAR'">
                    <b-form-group id="col-12 " label="Empresa *" label-for="empresa" class="col-12  px-1">
                        <b-form-select id="empresa" @change="changeContratoOptions" :disabled="empresaOptions.length == 1" 
                            v-model="empresaId" :options="empresaOptions" :state="empresaIdIsValid">
                        </b-form-select>
                        <b-form-invalid-feedback :state="empresaIdIsValid"> {{messageError}} </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group v-if="productOptions.length > 0" label="Serviço(s) *" label-for="checkbox-contrato-options" class="col-12 px-1">
                        <b-form-checkbox-group id="checkbox-contrato-options" v-model="productSelected" :options="productOptions"
                            name="checkbox-contrato-options" :state="productSelectedIsValid" @change="isNR01">
                        </b-form-checkbox-group>
                        <b-form-invalid-feedback :state="productSelectedIsValid"> {{messageError}} </b-form-invalid-feedback>
                    </b-form-group>                   
                </template>
                <template v-if="checkTipoBeneficiario == 'DEPENDENTE'">
                    <b-form-group id="input-group-2" label="ID" label-for="cpfTitular" class="col-12 col-lg-6 px-1">
                        <b-form-input readonly id="cpfTitular" :value="empresaId" @input="() => {}" trim ></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-2" label="CPF Titular" label-for="cpfTitular" class="col-12 col-lg-6 px-1">
                        <b-form-input readonly id="cpfTitular" v-model="cpfTitular" trim ></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-2" label="Tipo" label-for="titular" class="col-12 col-lg-6 px-1">
                        <b-form-input readonly id="titular" value="TITULAR" @input="() => {}" trim ></b-form-input>
                    </b-form-group>
                </template>

                <b-form-group id="name" label="Nome *" label-for="name" class="col-lg-6 col-12 px-1">
                    <b-form-input id="name" v-model="name" :state="nameIsValid" placeholder="digite aqui" trim ></b-form-input>
                        <b-form-invalid-feedback :state="nameIsValid" > {{messageError}} </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="E-mail 2 *" label-for="email2_id" class="col-lg-6 col-12 px-1" v-if="isMapeamento">
					<b-form-input id="email2_id" :state="email2IsValid" v-model="email2" trim maxlength="150"/>
					<b-form-invalid-feedback :state="email2IsValid" >{{ messageError }} </b-form-invalid-feedback>
				</b-form-group>

                <b-form-group id="cpf" label="CPF *" label-for="cpf" class="col-lg-6 col-12 px-1">
                    <b-form-input id="cpf" v-model="cpf" :state="cpfIsValid" placeholder="digite aqui" trim 
                    v-mask="['###.###.###-##']"></b-form-input>
                    <b-form-invalid-feedback :state="cpfIsValid" > {{messageError}} </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="status" label="Status *" label-for="status" class= "col-lg-6 col-12 px-1">
                    <b-form-select id="status" v-model="status" :options="statusOptions" :state="statusIsValid"></b-form-select>
                    <b-form-invalid-feedback :state="statusIsValid" >
                        {{messageError}}
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="" label="Data de Nascimento *" label-for="dataNascimento" class="col-lg-6 col-12 px-1">
                    <InputDate2 label="" v-model="dataNascimento" :state="dataNascimentoIsValid"/>
                </b-form-group>

                <b-form-group id="genero" label="Gênero" label-for="genero" class="col-lg-6 col-12 px-1">
                    <b-form-select id="genero" v-model="genero" :state="generoIsValid" :options="sexoOptions"></b-form-select>
                    <b-form-invalid-feedback :state="generoIsValid" >
                        {{messageError}}
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group v-if="checkTipoBeneficiario == 'DEPENDENTE'" id="input-group-2" label="Grau de parentesco: *" label-for="parentesco" class="col-lg-6 col-12 px-1">
                    <b-form-select id="parentesco" v-model="parentesco" :state="parentescoIsValid" :options="ParentescoOptions"></b-form-select>
                    <b-form-invalid-feedback :state="parentescoIsValid" >
                        {{messageError}}
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="input-group-2" label="CNPJ de Faturamento *" label-for="cnpjFaturamento" class="col-lg-6 col-12 px-1">
                    <b-form-input
                        id="cnpjFaturamento"
                        v-model="cnpjFaturamento"
                        :state="cnpjFaturamentoIsValid"
                        v-mask="['##.###.###/####-##']"
                        placeholder="digite aqui"
                        trim
                    ></b-form-input>
                    <b-form-invalid-feedback :state="cnpjFaturamentoIsValid" >
                        {{messageError}}
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="input-group-2" label="Local de trabalho (opcional)" label-for="localTrabalho" class="col-lg-6 col-12 px-1">
                    <b-form-input
                        id="localTrabalho"
                        v-model="localTrabalho"
                        placeholder="digite aqui"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" label="Unidade (opcional)" label-for="unidade" class="col-lg-6 col-12 px-1">
                    <b-form-input
                        id="unidade"
                        v-model="unidade"
                        placeholder="digite aqui"
                        trim
                    ></b-form-input>
                </b-form-group>

                <template v-if="nr01">
                    <b-form-group id="input-group-2" label="GHE" label-for="ghe" class="col-lg-6 col-12 px-1">
                        <b-form-input
                            id="ghe"
                            v-model="ghe"
                            placeholder="digite aqui"
                            trim
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Setor" label-for="setor" class="col-lg-6 col-12 px-1">
                        <b-form-input
                            id="setor"
                            v-model="setor"
                            placeholder="digite aqui"
                            trim
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Função" label-for="funcao" class="col-lg-6 col-12 px-1">
                        <b-form-input
                            id="funcao"
                            v-model="funcao"
                            placeholder="digite aqui"
                            trim
                        ></b-form-input>
                    </b-form-group>
                </template>

                <ModalAlert id="cadastrar-beneficiario-alert" @close="$bvModal.hide('modal-cadastrar-beneficiario')">
                    <DynamicIcon :icon="!errors ? 'check' : 'exclamation'" :classString="'alert-exclamation'"/>
                        {{message}}
                </ModalAlert>

                <ModalAlert id="modal-response-message-error" @close="$bvModal.hide('modal-response-message-error')">
                    <DynamicIcon icon="not" :classString="'alert-exclamation'"/>
                    {{ responseMessage }}
                </ModalAlert>

            </div>
            <template #modal-footer>
                <b-button pill class="btn-base outline-primary-btn optum-bold" @click="$bvModal.hide('modal-cadastrar-beneficiario')">Cancelar</b-button>
                <b-button pill class="btn-base primary-btn optum-bold" @click="salvar">Salvar</b-button>
            </template>	
    
        </b-modal>
    </div>
</template>
<script>

import InputDate2 from "@/components/commons/Inputs/InputDate2"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ModalAlert from "@/components/commons/ModalAlert.vue";
import DateUtils  from "@/util/DateUtils";
import Validations from "@/util/Validations";
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource";
import EmpresaResource from "@/resources/EmpresaResource";
import UserResource from "@/resources/UserResource";
import { getSexoOptions, getStatusOptions, getParentescoOptions } from "@/util/BeneficiarioUtils.js"
import { mask } from 'vue-the-mask'

export default {
    name: 'ModalCadastrarBeneficiario',
    props: {    
        acao: String,
        beneficiario: {
            type: [Object],
            required: false,
            default: null,
        }
    },
    components: {
        DynamicIcon,
        ModalAlert,
        InputDate2
    },
    directives: {mask},
    data (){
        return {
			empresaOptions: [],
            empresaId: null,
            empresaIdIsValid: null,
            cpfTitular: null,
            name: null,
            nameIsValid: null,
            cpf: null,
            email2: null,
            status: 1,
            statusIsValid: null,
            cpfIsValid: null,
            dataNascimento: null,
            dataNascimentoIsValid: null,
            genero: null,
            generoIsValid: null,
            parentesco: null,
            parentescoIsValid: null,
            cnpjFaturamento: null,
            cnpjFaturamentoIsValid: null,
            email2IsValid: null, 
            messageError: null,
            errors: null,
            message: null,
            localTrabalho: null,
            unidade: null,
            showWeekNumber: false,
            locale: 'pt-BR',
            validationMessage: null,
            ghe: null,
            setor: null,
            funcao: null,
            nr01: false,
            sexoOptions: getSexoOptions(),
            ParentescoOptions: getParentescoOptions(),
            statusOptions: getStatusOptions (),
            productSelected: [],
            productSelectedIsValid: null,
			productOptions: [],
            responseMessage: null,
        }
    },
    computed: {
        titleByTipoBeneficiario () {
            return this.checkTipoBeneficiario == "TITULAR" ? 'Titular' : 'Dependente'
        },
        iconByTipoBeneficiario () {
            if(this.acao != "CADASTRAR"){
                return 'color-pencil'
            }

            return this.checkTipoBeneficiario == "TITULAR" ? 'head-brain' : 'circle-people'
        },
        titleByAcao() {
            return this.acao == "CADASTRAR" ? 'Cadastrar' : 'Editar'
        },
        checkTipoBeneficiario ()
        {
            if (this.acao == "CADASTRAR")
            {
                return this.beneficiario == null ? 'TITULAR' : 'DEPENDENTE'
            }

            if(this.beneficiario)
            {
                return this.beneficiario.tipoId == 1 ? 'TITULAR' : 'DEPENDENTE'
            }

            return 'DEPENDENTE'
        },
        isMapeamento(){
            const regex = /mapeamento/

            for(let item of this.productSelected) {
                let product = this.productOptions.filter( product => product.value == item )[0]
                if (product && regex.test( product.text.toLowerCase() ) ) return true
            }

            if (this.beneficiario && this.beneficiario.produto && regex.test(this.beneficiario.produto)) return true 
            
            return false
        }
    },
    methods : {
        clearDate () {
                this.ano = null
        },
        salvar () {
            this.nameIsValid = null
            this.statusIsValid = null
            this.cpfIsValid = null
            this.dataNascimentoIsValid = null
            this.generoIsValid = null
            this.parentescoIsValid = null
            this.cnpjFaturamentoIsValid = null
            this.messageError = null
            this.errors = null
            this.message = null
            this.validationMessage = null
            this.email2IsValid = null 
            this.empresaIdIsValid = null

            if(this.validateEmptyField('empresaId', 'empresaIdIsValid')) 
                return false

            if(this.validateEmptyField('productSelected', 'productSelectedIsValid')) 
                return false

            if(this.validateEmptyField('name', 'nameIsValid')) 
                return false

            if(this.validateEmptyField('cpf', 'cpfIsValid')) 
                return false
                
            if(!Validations.validateCPF(this.cpf)) {
                this.isInValidField('cpfIsValid')
                return false
            }

            if(this.validateEmptyField('status', 'statusIsValid')) 
                return false
            
            if(this.validateEmptyField('dataNascimento', 'dataNascimentoIsValid')) 
                return false

            //if(this.validateEmptyField('genero', 'generoIsValid')) 
            //    return false
            
            if(this.checkTipoBeneficiario == 'DEPENDENTE')
            {
                if(this.validateEmptyField('parentesco', 'parentescoIsValid')) 
                    return false
            }

            if(this.validateEmptyField('cnpjFaturamento', 'cnpjFaturamentoIsValid')) 
                return false

            if(!Validations.validateCNPJ(this.cnpjFaturamento)) {
                this.isInValidField('cnpjFaturamentoIsValid')
                return false
            }

            if(this.isMapeamento && this.validateEmptyField('email2', 'email2IsValid')) 
                return false

            let data = {
                nome : this.name,
                cpf: this.cpf.replace(/[^\d]+/g,''),
                dataNascimento: DateUtils.formatNoTime(this.dataNascimento),
                genero: this.genero,
                cnpjFaturamento: this.cnpjFaturamento.replace(/[^\d]+/g,''),
                localTrabalho: this.localTrabalho,
                unidade: this.unidade,
                tipoBeneficiario: this.checkTipoBeneficiario,
                empresaId : this.empresaId,
                flgAtivacao: this.status,
                produto: this.productSelected.join(","),
                email2: this.email2,
                ghe: this.ghe,
                setor: this.setor,
                funcao: this.funcao
            }

            if(this.checkTipoBeneficiario == 'DEPENDENTE')
            {
                data.cpfTitular = this.cpfTitular.replace(/[^\d]+/g,'')
                let item = this.ParentescoOptions.find(item  => this.parentesco == item.value)
                data.parentesco = item ? item.text : ""
            }

            BeneficiarioImportacaoResource.adicionar( data, {showLoader: true})
            .then(response => {
                if(response.success)
                {
                    this.errors = false
                    this.message = this.getMessage()
                    this.$bvModal.show("cadastrar-beneficiario-alert");
                }

                this.name = null 
                this.nameIsValid = null
                this.cpf = null
                this.cpfIsValid = null
                this.dataNascimento = null
                this.dataNascimentoIsValid = null
                this.status = null
                this.genero = null
                this.generoIsValid = null
                this.parentesco = null
                this.parentescoIsValid = null
                this.cnpjFaturamento = null
                this.cnpjFaturamentoIsValid = null
                this.messageError = null
                this.localTrabalho = null
                this.unidade = null
                this.email2 = null
                this.ghe = null
                this.setor = null
                this.funcao = null
                this.nr01 = false
                this.productSelected = []

            }).catch(err => {

				this.showModalError(err)

                if(err.fieldErrors)
                {
                    for (let elem in  err.fieldErrors)
                    {
                        this.isInValidField(elem+'IsValid')
                    }
                }
            })

        },
        getMessage(){
            if(this.acao != "CADASTRAR") return "Suas alterações foram salvas"

            return `${this.checkTipoBeneficiario == 'DEPENDENTE' ? "Dependente" : "Funcionário"} cadastrado!`     
        },
        validateEmptyField(field, refIsValid)
        {
            if(this[field] == null || this[field].length == 0)
            {
                this[refIsValid] = false
                this.messageError = "Campo obrigatório"
                this.validationMessage = this.messageError
                return true
            }
            this[refIsValid] = null
            return false
        },
        isInValidField(refIsValid)
        {
            this[refIsValid] = false
            this.messageError = "Campo inválido"
            this.validationMessage = this.messageError
            return true
        },
        isNR01(produtoId)
        {
            if(!produtoId || produtoId.length == 0)
            {
                this.nr01 = false
                return
            }

            const programaId = 16 // NR_01
            this.nr01 = false
            
            for(let item of produtoId)
            {
                EmpresaResource.getProduto(programaId, item, {showLoader: true})
                .then(result => {
                    if(result)
                    {	
                        this.nr01 = result || false
                    }
                })
            }
        },
        changeContratoOptions()
		{
			EmpresaResource.contratoOptions(this.empresaId, {showLoader: true})
			.then(result => {
				if(Array.isArray(result))
				{	
					this.productOptions = result.map(elem => { return {'value': elem.id, 'text': elem.text } })
				}
			})
		},
        async findBeneficiario(beneficiarioId, showLoader = false)
        {
            try {
               return BeneficiarioImportacaoResource.beneficiario( beneficiarioId, {showLoader: showLoader})
            } 
            catch (error) {
                console.log(error)
            }
        },
		showModalError(err) {
			this.responseMessage = Validations.getMessageError(err.errors[0])
			this.$bvModal.show('modal-response-message-error')
		}
    },
    async mounted() {
        UserResource.empresa(null,{ showLoader: false})
        .then(result => {
			if(Array.isArray(result)) {
				if(result.length == 1) {
					this.empresaId = result[0].id
					this.changeContratoOptions()
				}
				this.empresaOptions = this.options = result.map(elem =>  Object.create({'value': elem.id, 'text': elem.text }) )
			}
		})

        if(this.acao == "EDITAR" && this.beneficiario)
        {
            let response = await this.findBeneficiario(this.beneficiario.id)
            if(response)
            {
                this.name = response.nome
                this.cpf = response.cpf
                this.status = response.flgAtivacao
                this.dataNascimento = response.dataNascimento
                this.genero = response.genero
                this.parentesco = response.parentesco
                this.cnpjFaturamento = response.cnpjFaturamento
                this.localTrabalho = response.localTrabalho
                this.unidade = response.unidade
                this.empresaId = response.empresaId
                this.cpfTitular = response.cpfTitular
                this.productSelected = response.produto ? response.produto.split(",") : []
                this.email2 = response.email2
                this.ghe = response.ghe
                this.setor = response.setor
                this.funcao = response.funcao
                this.nr01 = response.nr01 || false
                
                this.changeContratoOptions()
            }
        }

        if(this.acao == "CADASTRAR" && this.checkTipoBeneficiario == 'DEPENDENTE' && this.beneficiario)
        {
            let response = await this.findBeneficiario(this.beneficiario.id)
            if(response)
            {
                this.cpfTitular = response.cpf
                this.empresaId = response.empresaId
                this.productSelected = response.produto ? response.produto.split(",") : []
            }
        }
    }
}
</script>

<style>
#modal-cadastrar-beneficiario .modal-header .close{
    padding-right: 0px !important;
    padding-left: 0px !important;
}
</style>
<style scoped>

input, select {
    font-size: 14px !important;
    border: 1px solid #bbbec0 !important;  
}
</style>